const u = up.util;
up.FragmentScrolling = class FragmentScrolling extends up.FragmentProcessor {
    keys() {
        return super.keys().concat([
            'hash',
            'mode',
            'revealTop',
            'revealMax',
            'revealSnap',
            'scrollBehavior',
            'oldScrollTops',
        ]);
    }
    processPrimitive(opt) {
        switch (opt) {
            case 'top':
                return this._scrollTo(0);
            case 'bottom':
                return this._scrollTo(-0);
            case 'layer':
                return this._revealLayer();
            case 'main':
                return this._revealSelector(':main');
            case 'keep':
                return this._restoreOld();
            case 'restore':
                return this._restoreSaved();
            case 'hash':
                return this.hash && up.viewport.revealHash(this.hash, this.attributes());
            case 'target':
            case 'reveal':
            case true:
                return this._revealElement(this.fragment);
            default:
                if (u.isNumber(opt)) {
                    return this._scrollTo(opt);
                }
                else if (u.isString(opt)) {
                    return this._revealSelector(opt);
                }
        }
    }
    processElement(element) {
        return this._revealElement(element);
    }
    _revealElement(element) {
        if (element) {
            up.reveal(element, this.attributes());
            return true;
        }
    }
    _revealSelector(selector) {
        let match = this.findSelector(selector);
        return this._revealElement(match);
    }
    _revealLayer() {
        return this._revealElement(this.layer.getBoxElement());
    }
    _scrollTo(position) {
        return up.viewport.scrollTo(position, { ...this.attributes(), around: this.fragment });
    }
    _restoreOld() {
        if (this.oldScrollTops) {
            return this._restoreSaved({ scrollTops: this.oldScrollTops });
        }
    }
    _restoreSaved(extraOptions) {
        return up.viewport.restoreScroll({ ...this.attributes(), around: this.fragment, ...extraOptions });
    }
};
